import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Home from "./Components/HomeComp/home";
import Navbar from "./Components/MainComp/navbar";
import Footer from "./Components/MainComp/footer";
import ContactUs from "./Components/ContactComp/contactus";
import AboutUs from "./Components/AboutComp/aboutus";
import Bookings from './Components/BookingComp/bookings';
import FAQ from './Components/FAQComp/faq';
import Gallery from './Components/GalleryComp/gallery';
import Packages from './Components/PackagesComp/packages';
import WhatsAppButton from './Components/Whatsapp/WhatsAppButton';

import AirportTour from './Components/OurServicesComp/airport-tour';
import OutstationTour from './Components/OurServicesComp/outstation-tour';
import ShortLongTerm from './Components/OurServicesComp/short-long-term';
import CityRides from './Components/OurServicesComp/city-rides';
import WeddingTour from './Components/OurServicesComp/wedding-tour';








function App() {
  return (
    <Router>
    {/* <ScrollToTop /> */}
    <Navbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/bookings" element={<Bookings />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/packages" element={<Packages />} />

      <Route path='/airport-tour' element={<AirportTour />} />
      <Route path='/wedding-tour' element={<WeddingTour />} />
      <Route path='/city-rides' element={<CityRides />} />
      <Route path='/outstation-tour' element={<OutstationTour />} />
      <Route path='/short-long-term' element={<ShortLongTerm />} />






  
    </Routes>
    <Footer /> 
<WhatsAppButton />
           
   
  </Router>
  );
}

export default App;
